import React from 'react'
import { Route, IndexRoute } from 'react-router'
import * as Views from './views'
import Layout from './layout'

const Routes = (
  <Route path="flagged" component={Layout}>
    <IndexRoute component={Views.Flagged} />
  </Route>
)

export default Routes
